import { GridColumns } from 'shared/types';
import { GridInitialStatePremium } from '@mui/x-data-grid-premium/models/gridStatePremium';
import { AccountNumberParams } from 'pages/managePricing/managePricingResolver';
import { useParams } from 'react-router-dom';
import { TableDataPage } from 'shared/components';
import { createTableDataContext, ProvideTableData } from 'shared/providers/provideTableData';
import { AddDeviationsData } from 'types/backend';

interface PrivateProductsResolverProps {
    columnConfig: GridColumns<AddDeviationsData>
    toolbarChildren: JSX.Element[]
}

export const addDeviationsContext = createTableDataContext<AddDeviationsData>();
export function PrivateProductsResolver({columnConfig, toolbarChildren}: PrivateProductsResolverProps) {
    const params = useParams<AccountNumberParams>();

    const defaultPrivateAddDeviationsConfig: {initialState?: GridInitialStatePremium} | undefined = {
        initialState: {
            pagination: {
                paginationModel: {
                    page: 0,
                    pageSize: 100,
                },
            }
        },
    }

    return (
        <ProvideTableData
            name='ProductListUI'
            tableDataContext={addDeviationsContext}
            alternateQueryPath={`subset/${params.accountNumber}/productList/private`}
            config={defaultPrivateAddDeviationsConfig}
        >
            <TableDataPage
                title='Available Private Products'
                columnConfig={columnConfig}
                tableDataContext={addDeviationsContext}
                config={{
                    hideExport: true,
                }}
                customToolbarChildren={toolbarChildren}
            />
        </ProvideTableData>
    );
}
